export default __webpack_public_path__ + "static/media/icon-fifth-vacancy.04dc7c1a.svg";